/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_To_XmlInputs */

const en_sidebar_to_xml = /** @type {(inputs: Sidebar_To_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → XML`)
};

const ko_sidebar_to_xml = /** @type {(inputs: Sidebar_To_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → XML`)
};

const ja_sidebar_to_xml = /** @type {(inputs: Sidebar_To_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → XML`)
};

/**
* | output |
* | --- |
* | "JSON → XML" |
*
* @param {Sidebar_To_XmlInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_to_xml = /** @type {((inputs?: Sidebar_To_XmlInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_To_XmlInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_to_xml(inputs)
	if (locale === "ko") return ko_sidebar_to_xml(inputs)
	return ja_sidebar_to_xml(inputs)
});